import React from 'react'
import { Link } from 'gatsby'
import parser from 'html-react-parser'

export default function Content8({ data }) {
    const { content8ButtonText, content8Text, content8ButtonLink, content8Title, content8VideoUrl, content8ButtonExternalLink } = data
    return (
        <div className='join-our-movment-wrap panel-space-70 light-grey-bg'>
            <div className='container'>
                <div className='row v-center'>
                    <div className='col-md-6 join-our-movment-content'>
                        <h2 className='heading-level-2 blue-color'>{content8Title && parser(content8Title)}</h2>
                        <div className='hide-desk'>
                            <iframe
                                src={content8VideoUrl}
                                title='Comprehensive School Partnerships video'
                                width='640'
                                height='360'
                                allow='autoplay; fullscreen; picture-in-picture'
                                allowFullScreen
                            ></iframe>
                        </div>
                        <p>{content8Text && parser(content8Text)}</p>
                        {content8ButtonExternalLink ? (
                            <a href={content8ButtonExternalLink} className="btn blue-btn">
                                {content8ButtonText}
                            </a>
                        ) : content8ButtonLink ? (
                            <Link to={content8ButtonLink.uri} className='btn blue-btn'>
                                {content8ButtonText}
                            </Link>
                        ) : null}
                    </div>
                    <div className='col-md-6'>
                        <div className=' hide-mobile'>
                            <iframe
                                src={content8VideoUrl}
                                title='Comprehensive School Partnerships mobile video'
                                width='640'
                                height='360'
                                allow='autoplay; fullscreen; picture-in-picture'
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
} 
